import { Bounce, ToastContainer } from 'react-toastify'
import { appConfig } from '@/config/app.ts'

const ToastWrapper = () => (
  <ToastContainer
    position={appConfig.toasts.position}
    autoClose={appConfig.toasts.duration}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick={false}
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    theme="light"
    transition={Bounce}
  />
)

export default ToastWrapper
